import { APP_LOCALE_NAME_DEFAULT, APP_LOCALE_NAME_FALLBACK, APP_LOCALES } from '@ricoh/ria.client.core/constants/core/app';

import type { I18nConfig } from './_config.type';

const importResourcesModule = {
  ca: () => import('@ricoh/ria.client.core/plugins/i18n/resources/ca'),
  de: () => import('@ricoh/ria.client.core/plugins/i18n/resources/de'),
  en: () => import('@ricoh/ria.client.core/plugins/i18n/resources/en'),
  es: () => import('@ricoh/ria.client.core/plugins/i18n/resources/es'),
  fr: () => import('@ricoh/ria.client.core/plugins/i18n/resources/fr'),
  it: () => import('@ricoh/ria.client.core/plugins/i18n/resources/it'),
  ja: () => import('@ricoh/ria.client.core/plugins/i18n/resources/ja'),
  nl: () => import('@ricoh/ria.client.core/plugins/i18n/resources/nl'),
  pt: () => import('@ricoh/ria.client.core/plugins/i18n/resources/pt'),
  th: () => import('@ricoh/ria.client.core/plugins/i18n/resources/th'),
  vi: () => import('@ricoh/ria.client.core/plugins/i18n/resources/vi'),
  zh: () => import('@ricoh/ria.client.core/plugins/i18n/resources/zh'),
};

/** I18n config. */
export const i18nConfig: I18nConfig = {
  locales: APP_LOCALES,
  defaultLocale: APP_LOCALE_NAME_DEFAULT,
  fallbackLocale: APP_LOCALE_NAME_FALLBACK,
  namespaces: ['common', 'error', 'feature', 'layout', 'page', 'server', 'validation', 'worker'],
  defaultNamespace: 'common',

  getResources: async (locale) => {
    const importResoucesModule = importResourcesModule[locale] ?? importResourcesModule[APP_LOCALE_NAME_FALLBACK];
    const resoucesModule = await importResoucesModule();
    return resoucesModule.default;
  },
};
